import { useState, useEffect } from "react";
import { Check, UserPlus } from "lucide-react";
import { isFollowing, toggleFollow } from "../lib/userPrefs";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;

export default function FollowButton({ artistName, slug, size = "md", className = "" }) {
  const [following, setFollowing] = useState(false);

  useEffect(() => {
    setFollowing(isFollowing(artistName));
  }, [artistName]);

  if (!artistName) return null;

  const onClick = async (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    const wasFollowing = following;
    const now = toggleFollow(artistName);
    setFollowing(now);
    toast.success(now ? `Seguindo ${artistName}` : `Deixou de seguir ${artistName}`);
    if (slug) {
      try {
        const ep = wasFollowing ? "unfollow" : "follow";
        await fetch(`${API}/api/artists/${slug}/${ep}`, { method: "POST" });
      } catch {}
    }
  };

  const base =
    size === "sm"
      ? "px-3 py-1 text-xs"
      : size === "lg"
      ? "px-6 py-2.5 text-sm"
      : "px-4 py-1.5 text-xs";

  return (
    <button
      onClick={onClick}
      data-testid={`follow-${artistName}`}
      className={`inline-flex items-center gap-1.5 font-bold uppercase tracking-wider rounded-full transition-all ${base} ${
        following
          ? "bg-[#FF007F] text-white border-2 border-[#FF007F] hover:bg-[#FF007F]/80"
          : "bg-transparent text-white border-2 border-white/30 hover:border-[#FF007F] hover:text-[#FF007F]"
      } ${className}`}
    >
      {following ? <Check size={size === "lg" ? 18 : 14} /> : <UserPlus size={size === "lg" ? 18 : 14} />}
      {following ? "Seguindo" : "Seguir"}
    </button>
  );
}
